<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="profile-view">
    <div class="has-side-bars ">
      <h2>{{ $t('my_space') }}</h2>
      <div class="space-tabs">
        <div
          v-for="o in mySpaceOp"
          :key="o"
          class="tab-op"
          :class="o === selectedOp && 'selected'"
          @click="changeSelectedOp(o)"
        >
          <span>{{ $t(o) }}</span>
        </div>
      </div>
    </div>
    <ViewsLib v-if="selectedOp === 'view_lib'" />
    <FavList v-else-if="selectedOp === 'fav_list'" />
    <UserDates v-else-if="selectedOp === 'user_dates'" />
    <ComuPref v-else-if="selectedOp === 'comun_pref'" />
  </div>
</template>

<script>
import UserDates from '../components/profile/UserDates'
import ComuPref from '../components/profile/ComuPref'
import FavList from '../components/profile/FavList'
import ViewsLib from '../components/profile/ViewsLib'
export default {
  components: { UserDates, FavList, ViewsLib, ComuPref },
  props: {
    params: {
      type: String,
    },
  },
  data() {
    return {
      selectedOp: this.$route.params.optype ? this.$route.params.optype : 'view_lib',
      mySpaceOp: ['view_lib', 'fav_list', 'user_dates', 'comun_pref'],
    }
  },
  computed: {},
  watch: {},
  methods: {
    changeSelectedOp(op) {
      if (this.selectedOp !== op) {
        this.selectedOp = op
        this.$route.params.optype = op
        if (this.$route.params.optype || Object.keys(this.$route.query).length !== 0) {
          this.$router.push({
            name: this.$route.name,
            params: {
              lang: this.$route.params.lang,
              optype: this.$route.params.optype
            },
            query: {},
          })
        }
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.profile-view
  background-color: rgba($bcn-dark-blue-gray, 0.05)
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)

  h2
    m-font-size(32, 45)
    font-weight: 600
    margin-block-end: vw(15px)

  .space-tabs
    display: flex
    gap: vw(5px)

    .tab-op
      padding: vw(6px) vw(14px) vw(14px)
      m-font-size(16, 25)
      color: $grey-dark
      cursor: pointer

    .selected
      box-shadow: 0 -4px 0 0 $corporate_color inset
      color: $corporate_color
</style>